<template>
  <div>本月实收明细</div>
</template>
<script>
export default {}
</script>
<style lang=""></style>
